/* eslint-disable react-hooks/exhaustive-deps */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import React, { FC, useEffect, useState } from "react";
import OptionListNoSearch, {
  OptionListNoSearchProps,
} from "./OptionListNoSearch";
import { OptionData } from "./types";
import { containerCss, inputCss } from "./styles";
import { WithLoaderHOC, withLoaderHOC } from "../../atoms/Loader";

export type Props = OptionListNoSearchProps & {
  searchEnabled?: boolean;
  activeOptions: Set<string>;
  placeholder?: string;
};

const OptionList: FC<Props> = ({
  options,
  activeOptions, // = focused = právě vybrané
  searchEnabled,
  placeholder,
  ...rest
}) => {
  const [filteredOptions, setFilteredOptions] = useState<OptionData[]>(options);

  const [searchText, setSearchText] = useState("");

  const filterOptions = () => {
    const newFilteredOptions = options.filter((o: OptionData) =>
      o.text.toLowerCase().includes(searchText.toLowerCase())
    );

    setFilteredOptions(newFilteredOptions);
  };

  const unselectOptionsThatAreNotVisible = () => {
    const activeOptionsStillVisible = [...activeOptions].filter((value) =>
      filteredOptions.find((o) => o.value === value)
    );

    rest.onChangeOfActiveOptions(new Set(activeOptionsStillVisible));
  };

  useEffect(() => {
    filterOptions();
  }, [options, searchText]);

  useEffect(() => {
    // Když změním search query, odznač options, které zmizely
    unselectOptionsThatAreNotVisible();
  }, [searchText]);

  return (
    <div css={containerCss} data-cy="option-list">
      {searchEnabled && (
        <input
          css={inputCss}
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          placeholder={placeholder}
          data-cy="search-field"
          enterKeyHint="done"
        />
      )}
      <OptionListNoSearch {...rest} options={filteredOptions} />
    </div>
  );
};

export default withLoaderHOC(OptionList);
export type OptionListProps = WithLoaderHOC<Props>;
